/**
 * src/core/zasady/constants.ts — Centralne stałe biznesowe ProWycena.
 * Źródło prawdy dla wszystkich magic numbers w systemie.
 * Importuj stąd — nigdy nie definiuj stałych lokalnie w komponentach.
 */

// ─── KIO / Stawki minimalne ───────────────────────────────────────────────────

/**
 * Minimalna stawka RBG (zł/h) — KIO 4703/24, Dz.U.2021.2454.
 * WAŻNE: wartość 36.87, NIE 31.40. Wyrok KIO z 2024 roku.
 */
export const MIN_RBG_2026 = 36.87;

/** Bezpieczny próg RBG (zł/h) — zalecany bufor ponad minimum KIO */
export const SAFE_RBG_2026 = 38.00;

/** Stawka godzinowa brutto r-g ogólnobudowlany (zł/h) — Olsztyn 2026 */
export const STAWKA_GODZINOWA_KIO = 69;

// ─── Subskrypcje ─────────────────────────────────────────────────────────────

/** Koszt planu podstawowego (zł/mies.) — używany do kalkulacji ROI */
export const KOSZT_SUBSKRYPCJI_PLN = 49;

/** Koszt planu PRO (zł/mies.) */
export const KOSZT_SUBSKRYPCJI_PRO_PLN = 99;

// ─── Limity projektów ────────────────────────────────────────────────────────

/** Limit projektów dla konta trial (egzekwowany w Firestore rules) */
export const TRIAL_PROJECT_LIMIT = 30;

// ─── Materiały ────────────────────────────────────────────────────────────────

/** Narzut na materiały pomocnicze (taśmy, folie, szpachlówka itp.) */
export const MATERIALS_WASTE_FACTOR = 1.10;

/** Koszt materiałów pomocniczych jako % od materiałów głównych */
export const KOSZT_MATERIALY_POMOCNICZE_PROCENT = 0.05;

// Materiały — stawki MVP offline (Warmia 2026)
export const MATERIAL_RATE_M2 = 25.0;       // placeholder BOM
export const GRUNT_PLN_M2 = 7.0;            // gruntowanie ścian
export const GLADZ_PLN_M2 = 32.0;           // gładź gipsowa
export const MALOWANIE_PLN_M2 = 28.0;       // malowanie 2x
export const HYDROIZOLACJA_PLN_M2 = 45.0;   // strefa mokra
export const AKRYL_PLN_MB = 8.0;            // akrylowanie narożników

// ─── Marże ────────────────────────────────────────────────────────────────────

export const MARZA_ROBOCIZNA_PROCENT    = 0.30;
export const MARZA_MATERIALY_PROCENT    = 0.12;
export const MARZA_DOMYSLNA_PROCENT     = 0.15;

// ─── Bufory ryzyka ────────────────────────────────────────────────────────────

export const BUFOR_RYZYKA_WYSOKIE  = 0.15;
export const BUFOR_RYZYKA_SREDNIE  = 0.08;
export const BUFOR_RYZYKA_NISKIE   = 0.03;
export const RYZYKO_BUFOR_PCT      = 0.15;

// ─── Scenariusze cenowe ───────────────────────────────────────────────────────

export const SCENARIUSZ_EKONOMICZNY_MNOZNIK = 0.85;
export const SCENARIUSZ_PREMIUM_MNOZNIK     = 1.25;
export const AI_PEWNOSC_DOMYSLNA            = 85;

// ─── VAT ─────────────────────────────────────────────────────────────────────

export const VAT_DOMYSLNY_PROCENT  = 8;
export const VAT_MATERIALY_PROCENT = 23;

// ─── AI / limity techniczne ───────────────────────────────────────────────────

export const AI_TIMEOUT_MS           = 30_000;
export const MAX_ZDJECIA_ANALIZA     = 10;
export const MAX_ROZMIAR_ZDJECIA_MB  = 5;

// ─── Szacunkowe wartości pominięć (Leak defaults) ────────────────────────────

export const WARTOSC_HYDROIZOLACJA_SZACUNKOWA = 380;
export const WARTOSC_SZLIFOWANIE_SZACUNKOWA   = 220;
export const WARTOSC_AKRYL_SZACUNKOWA         = 150;
export const WARTOSC_GRUNT_SZACUNKOWA         = 180;
export const WARTOSC_TRANSPORT_WYWOZ_SZACUNKOWA = 250;
export const WARTOSC_DOMYSLNA_LEAK            = 200;

// ─── Region ───────────────────────────────────────────────────────────────────

export const DEFAULT_REGION = 'Warmińsko-Mazurskie';
export const REGION_DOMYSLNY      = 'mazowieckie';
export const MIASTO_REFERENCYJNE  = 'Olsztyn';

// Ryzyka — progi alertów
export const KIO_CONFIDENCE_THRESHOLD = 50; // min confidence AI
